import React from "react";
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListItemTextProps,
} from "@mui/material";

interface SettingsItemProps {
  icon: React.ReactNode;
  primaryText: string;
  onClick?: () => void;
  primaryTextStyle?: ListItemTextProps["style"];
}

const SettingsItem: React.FC<SettingsItemProps> = ({
  icon,
  primaryText,
  onClick,
  primaryTextStyle,
}) => {
  return (
    <>
      <ListItem>
        <ListItemButton style={{ borderRadius: 10 }} onClick={onClick}>
          <ListItemText primary={primaryText} style={primaryTextStyle} />
          <ListItemIcon>{icon}</ListItemIcon>
        </ListItemButton>
      </ListItem>
    </>
  );
};

export default SettingsItem;
